import type { FC } from 'react';
import React from 'react';
import { StyledTableHeaderItem } from './styled';

type TableHeaderItemProps = React.ComponentPropsWithoutRef<'th'>;

export const TableHeaderItem: FC<TableHeaderItemProps> = (props) => {
    return <StyledTableHeaderItem {...props} />;
};
